export function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
//# sourceMappingURL=arrays.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/utilities/common/arrays.js
// module id = 347
// module chunks = 0